import request from "@/libs/fetch";

export const addFavorite = async (id: number, type: 'event' | 'grant' | 'artist') => await request('/favorite', { data: { id, type }, type: 'post' })
export const delFavorite = async (id: number, type: 'event' | 'grant' | 'artist') => await request(`/favorite/${type}/${id}`, { type: 'delete' })
export const listFavorite = async (type: string, keyword: string, limit: number = 10, page: number = 1) => await request('/favorite/list', { params: { keyword, limit, page, type }, type: 'get' })
